// src/components/research/ResearchMindmapLevelChips.jsx
// Ebenen-Chips der Mindmap (ADR 0065, Nachtrag 3). Jeder Chip steht für eine
// Ebene und ist unabhängig an-/abwählbar: angewählt = die Knoten dieser Ebene
// werden angezeigt, abgewählt = die Ebene wird AUSGEBLENDET (nicht
// eingeklappt) — ihre Kinder rücken an den nächsten sichtbaren Vorfahren.
// Gleiche Komponente in der Toolbar und im PDF-Dialog, damit beide immer
// denselben Zustand zeigen. states[i] gehört zu Ebene i+1 ("on" | "off").

import React from "react";

const LEVEL_HINT = (n) =>
  n === 1
    ? "Ebene 1: Kapitel"
    : n === 2
      ? "Ebene 2: Unterkapitel und Fragen direkt am Kapitel"
      : `Ebene ${n}: Fragen/Folgefragen dieser Tiefe`;

const ResearchMindmapLevelChips = ({ states, onToggle, onAll, onNone }) => (
  <span className="mindmap-levels" role="group" aria-label="Ebenen ein-/ausblenden">
    <span className="mindmap-levels-label">Ebenen</span>
    {states.map((st, i) => {
      const n = i + 1;
      return (
        <button
          key={n}
          type="button"
          className={`mindmap-level-chip is-${st}`}
          aria-pressed={st === "on"}
          onClick={() => onToggle(n)}
          title={`${LEVEL_HINT(n)} · ${st === "on" ? "angezeigt — Klick blendet die Ebene aus" : "ausgeblendet — Klick blendet die Ebene ein"}`}
        >
          Ebene {n}
        </button>
      );
    })}
    <button type="button" className="mindmap-level-link" onClick={onAll} title="Alle Ebenen einblenden">
      Alle
    </button>
    <button type="button" className="mindmap-level-link" onClick={onNone} title="Alle Ebenen ausblenden (nur die Wurzel bleibt)">
      Keine
    </button>
  </span>
);

export default ResearchMindmapLevelChips;
